export default {
  not_set_up: {
    title: 'Varauksia ei ole vielä otettu käyttöön tälle sijainnille',
    description:
      'Sijainti saa varauksia, kun se on linkitetty Google-listaukseensa ja sillä on omistaja. Jos ravintolalla ei vielä ole omistajaa, lisää sellainen Tiimi-osiossa. Siihen asti varausten aukioloaikoja ei voi muokata täällä, eikä Verkkokaupan aukioloaikoihin tehtyjä muutoksia kopioida Varauksiin.',
  },
  company_not_loaded: {
    title: 'Varausasetuksia ei voitu ladata',
    description:
      'Tämän sijainnin varausasetuksia ei voitu ladata, joten varausten aukioloaikoja ei voi muokata juuri nyt. Yritä uudelleen.',
    retry: 'Yritä uudelleen',
  },
};
